import React, { useEffect, useMemo, useState } from 'react'
import { useLocation } from 'react-router-dom'

import { BlankPaddingView } from 'components/PaddingView'
import { EVENT_TYPE, STRING } from 'resources'
import { EXTERNAL_URLS } from 'resources/urls'
import { sendAnalyticsEvent } from 'services/analytics'

import SubscriptionStatus from './SubscriptionStatus'
import ProfileInfo from './ProfileInfo'
import ProfileInfoEditModal from './ProfileInfo/EditModal'
import DeleteStatus from './DeleteStatus'
import BreachStatus from './BreachStatus'
import { Container, LinkText, Link } from './styles'

const ProtectContent = () => {
  const location = useLocation()
  const [subscriptionStatus, setSubscriptionStatus] = useState(null)
  const [profileInfo, setProfileInfo] = useState({ userProfile: {}, emailAddresses: [] })
  const [isProfileInfoLoading, setIsProfileInfoLoading] = useState(true)
  const [editModalOpen, setEditModalOpen] = useState(false)
  const [brokerDeletes, setBrokerDeletes] = useState(null)
  const [breachCount, setBreachCount] = useState(null)

  const query = useMemo(() => new URLSearchParams(location.search), [location.search])
  const editProfile = query.get('editProfile')
  const token = query.get('token')

  useEffect(() => {
    if (editProfile === 'true') {
      if (token) {
        setEditModalOpen(false)
      } else {
        setEditModalOpen(true)
      }
    }
  }, [editProfile, token])

  useEffect(() => {
    if (subscriptionStatus && brokerDeletes && breachCount) {
      sendAnalyticsEvent(EVENT_TYPE.protectView, { subscriptionStatus, brokerDeletes, breachCount })
    } else if (!subscriptionStatus && !brokerDeletes && !breachCount) {
      sendAnalyticsEvent(EVENT_TYPE.protectView)
    }
  }, [subscriptionStatus, brokerDeletes, breachCount])

  return (
    <Container>
      <ProfileInfoEditModal
        isOpen={editModalOpen}
        toggle={() => setEditModalOpen(!editModalOpen)}
        profileInfo={profileInfo}
        setProfileInfo={setProfileInfo}
        isProfileInfoLoading={isProfileInfoLoading}
        subscriptionStatus={subscriptionStatus}
      />
      <SubscriptionStatus setSubscriptionStatus={setSubscriptionStatus} />
      <BlankPaddingView value="20px" />
      <ProfileInfo
        profileInfo={profileInfo}
        setProfileInfo={setProfileInfo}
        isProfileInfoLoading={isProfileInfoLoading}
        setIsProfileInfoLoading={setIsProfileInfoLoading}
        setEditModalOpen={setEditModalOpen}
      />
      <BlankPaddingView value="20px" />
      <DeleteStatus setBrokerDeletes={setBrokerDeletes} />
      <BlankPaddingView value="20px" />
      <BreachStatus setBreachCount={setBreachCount} />
      <BlankPaddingView value="20px" />
      <LinkText>
        {STRING.protect.chatbotCTA}
        <Link to={EXTERNAL_URLS.REKLAIM_PROTECT}>{STRING.protect.chatbotLink}</Link>
      </LinkText>
    </Container>
  )
}

export default ProtectContent
